<template>
  <div class="error-display">
    <slot></slot>
  </div>
</template>
<script setup lang="ts"></script>
<style scoped>
.error-display {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 20px;
  text-align: center;
  color: rgb(211 94 94);
  align-items: center;
  vertical-align: middle;
  justify-content: center;
}
</style>
